import Vue from 'vue'
import Router from 'vue-router'
import home from '../pages/home'
import Parent from '../pages/Parent'
import Products from '../pages/ProductSolutions';
import Detail from '../pages/ProductDetails';
import Shop from '../pages/ProductShop';
import System from '../pages/ProductSystem';
import Appreciation from '../pages/ProductAppreciation';
import Join from '../pages/JoinUs';
import JoinDetail from '../pages/JoinDetail';
import About from '../pages/AboutUs';
import News from '../pages/News';
import NewsDetail from '../pages/NewsDetail';
import Contact from '../pages/Contact';
import NewsDetailOne from '../pages/NewsOne'
import NewsDetailTwo from '../pages/NewsTwo'
import NewsDetailThree from '../pages/NewsThree'
import NewsAll from '../pages/NewsAll'
import NewsIndustry from '../pages/NewsIndustry'
import NewsDynamic from '../pages/NewsDynamic'
import NewsAward from '../pages/NewsAward'
import NewsResponsibility from '../pages/NewsResponsibility'

Vue.use(Router)

export default new Router({
    linkActiveClass: 'active',
    mode: 'history',    //该模式下没有 # 前缀
    routes: [
      {
        path: '/',
        component: home
      },
      {
        path: '/home',
        name: 'home',
        component: home
      },
      {
        path: '/about',
        name: 'about',
        component: About,
      },
      {
        path: '/Parent',
        name: 'Parent',
        component: Parent,
      },
      {
        path: '/products',
        name: 'products',
        component: Products,
      },
      {
        path: '/detail',
        name: 'detail',
        component: Detail,
      },
        {
            path: '/shop',
            name: 'shop',
            component: Shop,
        },
        {
            path: '/system',
            name: 'system',
            component: System,
        },
        {
            path: '/appreciation',
            name: 'appreciation',
            component: Appreciation,
        },
        {
            path: '/join',
            name: 'join',
            component: Join,
        },
        {
            path: '/join-detail',
            name: 'join-detail',
            component: JoinDetail,
        },
        {
            path: '/about',
            name: 'about',
            component: About,
        },
        {
            path: '/news',
            name: 'news',
            component: News,
            children: [
                {
                    path: '/',
                    name: 'news-all',
                    component: NewsAll
                },
                {
                    path: 'industry-news',
                    name: 'industry-news',
                    component: NewsIndustry
                },
                {
                    path: 'dynamic-news',
                    name: 'dynamic-news',
                    component: NewsDynamic
                },
                {
                    path: 'award-news',
                    name: 'award-news',
                    component: NewsAward
                },
                {
                    path: 'responsibility-news',
                    name: 'responsibility-news',
                    component: NewsResponsibility
                },
                {
                    path: 'news-detail-1',
                    name: 'news-detail-1',
                    component: NewsDetailOne
                },
                {
                    path: 'news-detail-2',
                    name: 'news-detail-2',
                    component: NewsDetailTwo
                },
                {
                    path: 'news-detail-3',
                    name: 'news-detail-3',
                    component: NewsDetailThree
                }
            ]
        },
        {
            path: '/new-detail',
            name: 'news-detail',
            component: NewsDetail,
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact,
        },
    ]
  })
